/**
 *  ┌─────────────────────────────────────────────────────────────┐
 *  │┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┐│
 *  ││Esc│!1 │@2 │#3 │$4 │%5 │^6 │&7 │*8 │(9 │)0 │_- │+= │|\ │`~ ││
 *  │├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴───┤│
 *  ││ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{[ │}] │ BS  ││
 *  │├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤│
 *  ││ Ctrl │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  ││
 *  │├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────┬───┤│
 *  ││ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│Shift │Fn ││
 *  │└─────┬──┴┬──┴──┬┴───┴───┴───┴───┴───┴──┬┴───┴┬──┴┬─────┴───┘│
 *  │      │Fn │ Alt │         Space         │ Alt │Win│   HHKB   │
 *  │      └───┴─────┴───────────────────────┴─────┴───┘          │
 *  └─────────────────────────────────────────────────────────────┘
 *
 * Description:
 * Author: wangjian@12552
 * Date: 2023-08-03 13:43:03
 * LastEditors: wangjian@12552
 * LastEditTime: 2023-11-16 15:18:13
 * FilePath: \xiaoyutongxue\static\products.js
 */
const MeunsItemList = [
  {
    text: 'Architectural Glass',
    img: '/static/productImg/clearGlass/img1.jpg',
    childMenu: [
      {
        text: 'Laminated Glass',
        title: 'Laminated Glass',
        DESCRIPTION:
          'Laminated glass is commonly used as a safety glass . It comprises of two or more layers of glass which are permanently bonded together using an interlayer polyvinyl butryal（PVB). laminated glass as a Grade A Safety Glass. Upon impact, the glass may break, but due to the presence of the PVB-film, the laminated glass forms a star break, while toughened glass immediately falls apart into thousands of tiny pieces. Moreover, the laminated glass, unlike the toughened glass, can be sawed, cut or drilled. <br /> Furthermore, the PVB-film functions as a UV filter and protects the goods behind the glass from coloration. <br /> Laminated glass is also sound insulating and can provide optimal warmth-insulation in combination with double-glazing. <br /> Laminated glass is often applied as extra protection in windows, balconies or sloping roof glazing. Certain versions also form an excellent security against burglary attempts with a sledgehammer or burners.',
        SPECIFICATION:
          '  <br />  <strong>Thickness:</strong> <br /> 2.5+2.5mm, 3+3mm, 4+4mm, 5+5mm, 6+6mm, 8+8mm, 10+10mm, 12+12mm etc… <br /> <strong> Total Thickness:</strong> <br /> 5.38-21.52mm etc… <br /> <strong> Size:</strong>  <br />  2440*1830mm,3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,etc…  Max size: 3660*2550mm <br /> <strong> Colors:</strong>  <br />  Clear, Milk white, Green, Blue, Bronze, Grey etc…  <br /> <strong> Interlayer: </strong> <br />   SGP, PVB , EVA',
        APPLICATIONS:
          '- Safety glass <br /> - Burglary glass <br /> - Bulletproof glass <br /> - Colored glass <br /> - Automotive glass <br /> - Maritime glass <br /> - Design glas <br /> - Staircases <br /> - Bent glass ',
        img: '/static/productImg/LaminatedGlass/img1.jpg',
        imgClistFlie: 'LaminatedGlass',
        imgList: [
          { img: '/static/productImg/LaminatedGlass/img1.jpg' },
          { img: '/static/productImg/LaminatedGlass/img12.jpg' },
          { img: '/static/productImg/LaminatedGlass/img3.jpg' },
          { img: '/static/productImg/LaminatedGlass/img4.jpg' },
          { img: '/static/productImg/LaminatedGlass/img6 2.jpg' },
          { img: '/static/productImg/LaminatedGlass/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/LaminatedGlass/img18.jpg' },
          { img: '/static/productImg/LaminatedGlass/img6.jpg' },
          { img: '/static/productImg/LaminatedGlass/img17.jpg' },
          { img: '/static/productImg/LaminatedGlass/img5 2.jpg' },
        ],
      },

      {
        text: 'Tempered Glass',
        title: 'Tempered Glass',
        DESCRIPTION:
          'Tempered glass is a type of glass that is processed with thermal or chemical treatments, which increase its strength. The process of tempering leaves the outer surface of glass in a state of compression, and the interior in a state of tension. Thanks to that process it is more resistant to shock: 5 to 8 times of durability and 3 to 5 times of flexural strength more than ordinary annealed glass. Even if broken for some extreme reason, the small glass fragments are almost harmless to human body.<br />   <br /> <strong> ADVANTAGES</strong> <br /> Let us have a look into the advantages of toughened glass that makes its superior to ordinary glass. <br /> <strong> Strength and safety : </strong> Toughened glass is extremely strong and can counter any temperatures and climatic changes and are less likely to break. <br /> <strong> Scratch proof :</strong>Toughened glass is scratch proof and capable of maintaining the sheen and elegance of structures for years. <br /> <strong> Heat resistance : </strong> Normal glass may crack in high temperatures where as the toughened glass manufacturing process involves heat tempering and hence capable of resisting high temperatures. <br /> <strong> Design flexibility : </strong> Toughened glass got several design options like frosted, translucent, coloured, laminated options. ',
        SPECIFICATION:
          '<br />  <strong>Thickness:</strong> <br />  3mm, 3.2mm, 4mm, 5mm, 6mm, 8mm, 10mm, 12mm, 15mm, 19mm, 22mm, 25mm (1/8 inch to 1 inch) <br /> <strong> Size:</strong> <br />  As per customer requirements,<br />  Max raw glass size 4600mm*9000mm or 3300mm*22000mm (180*354 inch or 130*866 inch)  <br /> <strong> Color:</strong> <br />   Clear, Ultra Clear, Bronze, Grey, Blue, Green, etc...<br /> <strong> Optional Processing:</strong> <br />  Edging, Polishing, Drilling holes, Side opening, Cut to size, Coating, Printing, Laminating',
        Advantages:
          'Let us have a look into the advantages of toughened glass that makes its superior to ordinary glass. <br /> Strength and safety : Toughened glass is extremely strong and can counter any temperatures and climatic changes and are less likely to break. <br /> Scratch proof : Toughened glass is scratch proof and capable of maintaining the sheen and elegance of structures for years. <br /> Heat resistance : Normal glass may crack in high temperatures where as the toughened glass manufacturing process involves heat tempering and hence capable of resisting high temperatures. <br /> Design flexibility : Toughened glass got several design options like frosted, translucent, coloured, laminated options.',
        APPLICATIONS:
          '- architectural components <br /> - shower doors <br /> - vehicle windows <br /> - refrigerator trays,',
        img: '/static/productImg/TemperedGlass/img1.jpg',
        imgClistFlie: 'TemperedGlass',
        imgList: [
          { img: '/static/productImg/TemperedGlass/img1.jpg' },
          { img: '/static/productImg/TemperedGlass/img2.jpg' },
          { img: '/static/productImg/TemperedGlass/img4.jpg' },
          { img: '/static/productImg/TemperedGlass/img5.jpg' },
          { img: '/static/productImg/TemperedGlass/img6.jpg' },
          { img: '/static/productImg/TemperedGlass/img7.jpg' },
          { img: '/static/productImg/TemperedGlass/img8.jpg' },
          { img: '/static/productImg/TemperedGlass/img9.jpg' },
          { img: '/static/productImg/TemperedGlass/img10.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/TemperedGlass/img16.jpg' },
          { img: '/static/productImg/TemperedGlasss/img9.jpg' },
          { img: '/static/productImg/TemperedGlass/img9.jpg' },
          { img: '/static/productImg/TemperedGlass/img14.jpg' },
        ],
      },

      // {
      //   text: 'Tempered Laminated Glass',
      //   title: 'Tempered Laminated Glass',
      //   DESCRIPTION:
      //     'Tempered or Heat-strengthened Laminated glass is a combination of 2 or more sheets of glass with 1 or more foil interlayer fused together by heat and pressure. It gains all advantages of both Tempered (Heat-Strengthened) and Laminated glass via excellent safety conditions, noise reduction and UV –control.',
      //   SPECIFICATION:
      //     'Thickness: 3mm+3mm; 4mm+4mm; 5mm+5mm; 6mm+6mm; 8mm+8mm; 10mm+10mm; 12mm+12mm, etc',
      //   Size: ' As per customer requirements, Max raw glass size 4600mm*9000mm or 3300mm*22000mm (180*354 inch or 130*866 inch)',
      //   Color: 'Clear, Ultra Clear, Tinted, Coated',
      //   APPLICATIONS:
      //     '- curtain walls <br /> - floors <br /> - railings <br /> - roofs <br /> - security partitions <br /> - walls- etc..',
      //   img: '/static/productImg/TemperedLaminatedGlass/img1.jpg',
      //   imgClistFlie: 'TemperedLaminatedGlass',
      //   imgList: [
      //     { img: '/static/productImg/TemperedLaminatedGlass/img1.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img2.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img3.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img4.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img5.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img6.jpg' },
      //     { img: '/static/productImg/TTemperedLaminatedGlass/img7.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img8.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img9.jpg' },
      //     { img: '/static/productImg/TemperedLaminatedGlass/img10.jpg' },
      //   ],
      // },

      {
        text: 'Insulated Glass',
        title: 'Insulated Glass',
        DESCRIPTION:
          'Insulating Glass Units improve thermal performance by providing a thermal break between the glass and the sealed air spacer. The IG units are a high quality, total energy performance product that translate into reduced energy cost and increased comfort. The IG units will keep the heat in during the cold weather and will retain the heat out during the hot weather. The IG units can give a greater value when conjunction with Low-E and reflective coated glass. Low-E glass should always be insulated with the coating to the inside.',
        IGUNITSCONSISTOFFTHEFOLLOWING:
          'Polysulfide (standard) Primary sealButyl Secondary seal					Two or more lites of glass					Argon gas-fill (Optional when Low E Used)Aluminum Spacer with integral desiccantUnit thickness from 1/2" inches to 1 1/2" inches ',
        SPECIFICATION:
          '<br />   <strong>Thickness:</strong>  <br /> 5mm+9A+5mm; 6mm+9A+6mm; 8mm+9A+8mm; 10mm+9A+10mm; 12mm+12A+12mm; 15mm+15A+15mm; 19mm+18A+19mm (Customization available）<br /> <strong> Size:</strong> <br />   As per request, maximum 2500mm*6000mm',
        APPLICATIONS:
          'IG units or "double-pane" glass are usually used in residential, commercial and industrial constructions. These types of IG Units are required by building codes in many areas as mandatory energy conservation measure.',
        img: '/static/productImg/InsulatedGlass/img1.jpg',
        imgClistFlie: 'InsulatedGlass',
        imgList: [
          { img: '/static/productImg/InsulatedGlass/img1.jpg' },
          { img: '/static/productImg/InsulatedGlass/img2.jpg' },
          { img: '/static/productImg/InsulatedGlass/img3.jpg' },
          { img: '/static/productImg/InsulatedGlass/img4.jpg' },
          { img: '/static/productImg/InsulatedGlass/img5.jpg' },
          { img: '/static/productImg/InsulatedGlass/img7.jpg' },
          { img: '/static/productImg/InsulatedGlass/img8.jpg' },
          { img: '/static/productImg/InsulatedGlass/img9.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/InsulatedGlass/img13.jpg' },
          { img: '/static/productImg/InsulatedGlasss/img13.jpg' },
          { img: '/static/productImg/InsulatedGlass/img6.jpg' },
          { img: '/static/productImg/InsulatedGlass/img10.jpg' },
        ],
      },

      {
        text: 'Curved Glass',
        title: 'Curved Glass',
        DESCRIPTION:
          'The ordinary curved glass is made by heating up annealed glass to its softening temperature and then bended to the shape by weight or external force in special molds followed by cooling down. The curved tempered glass or curved heat-strengthened glass has same high-intensity, safety and thermal stability as flat tempered or heat-strengthened glass. ',
        Colors:
          '<br /> <strong> Curved GlassIs Available On The Glass Base As Follows</strong>   <br /> Clear glass Extra clear glass Tinted glass  <br /> <br /> <strong> Available Curved Glass</strong>   <br /> Curved glass <br /> Curved Tempered glass		<br />	Curved Heat-strengthened glass	<br />	Curved Laminated glass		<br />	Curved Tempered Laminated glass		<br />	Curved Heat-strengthened Laminated glass <br /> Curved Tempered (or heat-strengthened) Silk-screened glass <br /> Curved Tempered (or heat-strengthened) Enameled glass		<br />	Curved Tempered (or heat-strengthened) Digital print glass		<br />	Curved Tempered (or heat-strengthened) Laminated Silk-screened glass	<br />	Curved Tempered (or heat-strengthened) Laminated Enameled glass etc...',
        AvailableCurvedGlass:
          '	Curved glass Curved Tempered glass					Curved Heat-strengthened glass					Curved Laminated glass					Curved Tempered Laminated glass					Curved Heat-strengthened Laminated glassCurved Tempered (or heat-strengthened) Silk-screened glassCurved Tempered (or heat-strengthened) Enameled glass					Curved Tempered (or heat-strengthened) Digital print glass					Curved Tempered (or heat-strengthened) Laminated Silk-screened glass					Curved Tempered (or heat-strengthened) Laminated Enameled glass etc..',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br />  4-19 mm <br /> <strong> Maximum Size:</strong> <br /> 3200 x 8000 mm Different radius Different shapes Different edge work and drills <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />',
        img: '/static/productImg/CurvedGlass/img2.jpg',
        imgClistFlie: 'CurvedGlass',
        imgList: [
          { img: '/static/productImg/CurvedGlass/img1.jpg' },
          { img: '/static/productImg/CurvedGlass/img3.jpg' },
          { img: '/static/productImg/CurvedGlass/img7.jpg' },
          { img: '/static/productImg/CurvedGlass/img10.jpg' },
          { img: '/static/productImg/CurvedGlass/img6.jpg' },
          { img: '/static/productImg/CurvedGlass/img7.jpg' },
          { img: '/static/productImg/CurvedGlass/img8.jpg' },
          { img: '/static/productImg/CurvedGlass/img4.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/CurvedGlass/img14.jpg' },
          { img: '/static/productImg/CurvedGlasss/img14.jpg' },
          { img: '/static/productImg/CurvedGlass/img15.jpg' },
          { img: '/static/productImg/CurvedGlass/img9.jpg' },
        ],
      },

      {
        text: 'Heat Soaked Glass',
        title: 'Heat Soaked Glass',
        DESCRIPTION:
          'Our heat soaked glass greatly reduces the possibility of unforced breakage and is perfect for applications where additional strength is required.						Glass is formed by combining sand, soda ash, limestone, dolomite, salt cake and various other ingredients into a furnace heated to a temperature around 1500°C. During this process extremely small quantities of nickel sulphide (not visible to the naked eye) can be left undissolved in the glass.Due to the rapid cooling nature of glass toughening, the nickel sulphide in the glass does not have time to cooldown and is left in its high temperature state. Overtime the nickel will return to its low temperature state whilst increasing in volume. It is this volume increase that causes great stresses in the glass that can cause breakage. <br /> <br /> Heat soaking is a process in which tempered glass is subjected to a temperature of 290°C for several hours in a heat-soaking oven. This will cause the panel to break if any nickel sulphide inclusions are found.It is estimated that up to 95% of nickel sulphide-contaminated panes of glass are usually destroyed by this process, reducing the chance of on-site spontaneous breakage.',
        SPECIFICATION:
          '<br />    <strong> Thickness:</strong> <br />   4mm,5mm,5.5mm,6mm,8mm,10mm,12mm,15mm,19mm etc... <br /> <strong> Size:</strong> <br />  As per customer requirements ',
        APPLICATIONS:
          '- High rise glass facades <br /> - Overhead glazing <br /> - Balconies and balustrades <br /> - Any application where a superior toughened glass is required',
        img: '/static/productImg/HeatSoakedGlass/img6.jpg',
        imgClistFlie: 'HeatSoakedGlass',
        imgList: [
          { img: '/static/productImg/HeatSoakedGlass/img6.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img10.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img1.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img2.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img3.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img4.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/HeatSoakedGlass/img11.jpg' },
          { img: '/static/productImg/HeatSoakedGlasss/img11.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img5.jpg' },
          { img: '/static/productImg/HeatSoakedGlass/img9.jpg' },
        ],
      },

      {
        text: 'One Way Mirror Glass',
        title: 'One Way Mirror Glass',
        DESCRIPTION:
          'One way mirror glass is one kind of high technology glass mirror which is partially reflective and partially transparent. It is usually being used as a regular mirror in bright room,with a much darker room on the other side. People on the bright side can see only their reflection and it looks like regular mirror. People on the dark side can see through it, almost like through transparent window. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> 3mm, 5mm, 6mm, etc... <br /> <strong> Size:</strong>   3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,etc. <br /> <strong> Color:</strong> silvery gray  <br /> <strong> Deep Processing: </strong>   Tempered, laminated',
        APPLICATIONS:
          'This type of glass is commonly used in various applications, such as architectural facades, skylights, electronic displays, and automotive windows. Heat-strengthened glass provides a good balance between strength and flexibility, making it an ideal choice for various applications that require a strong yet durable glass product.',
        img: '/static/productImg/OneWayGlass/img1.jpg',
        imgList: [
          { img: '/static/productImg/OneWayGlass/img1.jpg' },
          { img: '/static/productImg/OneWayGlass/img2.jpg' },
          { img: '/static/productImg/OneWayGlass/img3.jpg' },
          { img: '/static/productImg/OneWayGlass/img4.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/OneWayGlass/img1.jpg' },
          { img: '/static/productImg/OneWayGlass/img2.jpg' },
          { img: '/static/productImg/OneWayGlass/img3.jpg' },
          { img: '/static/productImg/OneWayGlass/img4.jpg' },
        ],
      },

      {
        text: 'Dicoroic Glass',
        title: 'Dicoroic Glass',
        DESCRIPTION:
          'Dichroic glass, also called fusion glass, is glass treated with various metal oxides to make it appear to have many colors. Developed for use in the American space program, dichroic glass is now polular. <br />  <br /> Dichroic glass is innately interactive in nature. As the viewer‘s angle to the glass changes, so does its color, giving its kinetic iridescent characteristics.',
        Colors:
          '<br /> <strong> IG UNITS CONSIST OFF THE FOLLOWING:</strong>   <br /> Polysulfide (standard) Primary sealButyl Secondary seal					Two or more lites of glass					Argon gas-fill (Optional when Low E Used)Aluminum Spacer with integral desiccantUnit thickness from 1/2" inches to 1 1/2" inches',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br />   4mm-12mm <br /> <strong> Size:</strong>   <br />   2440*1830mm,3300*2140mm,3660*2140mm, etc...',
        APPLICATIONS:
          '- Shopping Malls <br /> - Partition Walls, Doors  <br /> - Cinemas <br /> - Museums',
        img: '/static/productImg/DicoroicGlass/img3.jpg',
        imgClistFlie: 'DicoroicGlass',
        imgList: [
          { img: '/static/productImg/DicoroicGlass/img1.jpeg' },
          { img: '/static/productImg/DicoroicGlass/img2.jpg' },
          { img: '/static/productImg/DicoroicGlass/img4.jpg' },
          { img: '/static/productImg/DicoroicGlass/img5.jpg' },
          { img: '/static/productImg/DicoroicGlass/img6.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/DicoroicGlass/img3.jpg' },
          { img: '/static/productImg/DicoroicGlass/img7.jpg' },
          { img: '/static/productImg/DicoroicGlass/img8.jpg' },
          { img: '/static/productImg/DicoroicGlass/img4.jpg' },
        ],
      },
    ],
  },
  {
    text: 'Mirror',
    img: '/static/productImg/clearGlass/img1.jpg',
    childMenu: [
      {
        text: 'Aluminum Mirror',
        title: 'Aluminum Mirror',
        DESCRIPTION:
          'Aluminum mirror glass uses the most advanced vacuum magnetron sputtering technology to produce environmentally friendly aluminum mirrors through the aluminum mirror horizontal production line. All aluminum mirrors glass are made of high quality float glass. High quality aluminum glass mirror sheet is usually coated by two layers paints.Univers only offer the best quality aluminum mirrors in China for any processing and edge processing, such as decorative mirrors, bevel mirrors, shaped mirrors, frames, frames, vanity mirrors, furniture mirrors, art mirrors, bathroom mirrors, cosmetic mirrors, hotel mirrors. And other processed mirrors..',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 1.1mm, 1.8mm, 2mm,2.7mm,3mm,4mm,5mm,6mm,8mm,etc... <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1830*2140mm,1830*2440mm etc...<br /> <strong> Back Paint Color:</strong>   <br /> Grey, Blue, Green, White etc... ',
        APPLICATIONS:
          ' - Decoration and furniture <br /> - Bathroom mirrors <br /> - Rearview mirror for automobile <br /> - Material mirror for safety mirror and shaped mirror and beveled mirror <br /> - Fitness/Gym Mirror',
        img: '/static/productImg/AluminumMirror/img6.jpg',
        imgClistFlie: 'AluminumMirror',
        imgList: [
          { img: '/static/productImg/AluminumMirror/img1.jpg' },
          { img: '/static/productImg/AluminumMirror/img2.jpg' },
          { img: '/static/productImg/AluminumMirror/img3.jpg' },
          { img: '/static/productImg/AluminumMirror/img4.jpg' },
          { img: '/static/productImg/AluminumMirror/img5.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/AluminumMirror/img8.jpg' },
          { img: '/static/productImg/AluminumMirrors/img8.jpg' },
          { img: '/static/productImg/AluminumMirror/img11.jpg' },
          { img: '/static/productImg/AluminumMirror/img9.jpg' },
        ],
      },

      {
        text: 'Silver Mirror',
        title: 'Silver Mirror',
        DESCRIPTION:
          'Silver mirror is based on high quality distortion-free float glass. It is produced by coating a silver film, a copper film and two or more layers of waterproof paint on the back surface of float glass.  ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 1.1mm, 1.8mm, 2mm, 2.7mm, 2.5mm, 3mm, 4mm, 5mm,5 .5mm, 6mm, 8mm,10mm,12mm,15mm,19mm etc...<br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1830*2140mm,1830*2440mm etc...<br /> <strong>Mirror Colors:</strong>   <br />  Bronze, Clear, Pink, Golden, Dark Grey, Euro Grey, Lake Blue, Ultra clear,  etc...',
        MirrorColors:
          '- Bronze- Clear- Pink- Golden - Dark Grey- Euro Grey- Lake Blue - Ultra clear  etc. ',
        APPLICATIONS:
          ' - Decoration and furniture <br /> - Bathroom mirrors <br /> - Rearview mirror for automobile <br /> - Material mirror for safety mirror and shaped mirror and beveled mirror <br /> - Fitness/Gym Mirror',
        img: '/static/productImg/SilverMirror/img2.jpg',
        imgClistFlie: 'SilverMirror',
        imgList: [
          { img: '/static/productImg/SilverMirror/img1.jpg' },
          { img: '/static/productImg/SilverMirror/img3.jpg' },
          { img: '/static/productImg/SilverMirror/img4.jpg' },
          { img: '/static/productImg/SilverMirror/img5.jpg' },
          { img: '/static/productImg/SilverMirror/img6.jpg' },
          { img: '/static/productImg/SilverMirror/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/SilverMirror/img2.jpg' },
          { img: '/static/productImg/SilverMirror/img7.jpg' },
          { img: '/static/productImg/SilverMirror/img10.jpg' },
          { img: '/static/productImg/SilverMirror/img9.jpg' },
        ],
      },

      {
        text: 'Copper Lead Free Mirror',
        title: 'Copper Lead Free Mirror',
        DESCRIPTION:
          'A copper-free silver mirror is also known as an environmentally friendly silver mirror. As the name implies, it refers to a silver mirror that does not contain copper, unlike ordinary silver mirrors with copper.Copper and Lead Free Mirror is made with no With a super sensitized palladium chloride instead of traditional copper layer , silver grain clusters more fine, double passivation , spraying double imported lead-free environment friendly corrosion resistant waterproof paint , dried by far infrared .',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm, 4mm, 5mm, 6mm etc... <br /> <strong> Size:</strong>   <br />3300*2140mm, 3660*2140mm, 3300*2250mm, 3660*2250mm, 3300*2440mm,3660*2440mm, 1650*2140mm, 1650*2250mm, 1650*2440mm, 1830*2140mm, 1830*2440mm etc... <br /> <strong>Mirror Colors:</strong>   <br />  Clear, Ultra clear, Grey, Blue, ,  etc...',
        MirrorColors: '- Clear- Ultra Clear- Dark Blue- Dark Green etc. ',
        APPLICATIONS:
          ' - Decoration <br /> - Furniture <br /> - Bathrooms <br /> - Seashore buildings ',
        img: '/static/productImg/CopperFreeMirror/img1.jpg',
        imgClistFlie: 'CopperFreeMirror',
        imgList: [
          { img: '/static/productImg/CopperFreeMirror/img1.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img2.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img3.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img5.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img6.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img9.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/CopperFreeMirror/img4.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img8.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img6.jpg' },
          { img: '/static/productImg/CopperFreeMirror/img7.jpg' },
        ],
      },

      {
        text: 'Epoxy Mirror',
        title: 'Epoxy Mirror',
        DESCRIPTION:
          'Epoxy mirror is new generation copper free mirror, whose performance has been significantly upgraded. FENZI new generation paint-EPOXY which have better protection and better corrossion resistance and better acid resistance.The paint side is firm and smooth, the glass side is clear and bright.				Under same environment and condition, Expoxy mirror has better anticorossion ability then before paint and pass CASS 600 Hours tess without obvious corrosion.The paint protect-bility of epoxy mirror is much better, so the lifitime will be  three times longer than common mirror, and the performance is certainly better.Copper free silver mirror epoxy back is a kind of environmental mirror. Back Paint is more stable. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm,4mm,5mm,5.5mm,6mm,etc... <br /> <strong> Size:</strong>   <br /> 3300*2140mm, 3660*2140mm, 3300*2250mm, 3660*2250mm, 3300*2440mm, 3660*2440mm, 1650*2140mm, 1650*2250mm, 1650*2440mm, 1830*2140mm, 1830*2440mm etc...',
        APPLICATIONS:
          ' - Decoration <br /> - Furniture <br /> - Bathrooms <br /> - Seashore buildings   ',
        img: '/static/productImg/EpoxyMirror/img2.jpg',
        imgClistFlie: 'EpoxyMirror',
        imgList: [
          { img: '/static/productImg/EpoxyMirror/img1.jpg' },
          { img: '/static/productImg/EpoxyMirror/img2.jpg' },
          { img: '/static/productImg/EpoxyMirror/img3.jpg' },
          { img: '/static/productImg/EpoxyMirror/img4.jpg' },
          { img: '/static/productImg/EpoxyMirror/img5.jpg' },
          { img: '/static/productImg/EpoxyMirror/img6.jpg' },
          { img: '/static/productImg/EpoxyMirror/img7.jpg' },
          { img: '/static/productImg/EpoxyMirror/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/EpoxyMirror/img10.jpg' },
          { img: '/static/productImg/EpoxyMirror/img7.jpg' },
          { img: '/static/productImg/EpoxyMirror/img8.jpg' },
          { img: '/static/productImg/EpoxyMirror/img5.jpg' },
        ],
      },

      {
        text: 'Safety Mirror',
        title: 'Safety Mirror',
        DESCRIPTION:
          'Safety mirror also called as vinyl backed safed mirror, safety backed mirror, vinyl backed mirror, vinyl backed silver mirror, etc. Safety mirror is produced by covering and adhesive PE (vinyl film) on the back all kinds of mirrors, the vinyl film include smooth finish  (CAT I /PC film) and woven fabric finish  (CAT II/Lattice film) with different colors, the film provents people from being hurt in case of mirror breaking.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 2mm, 2.7mm, 3mm, 4mm, 5mm, 6mm etc... <br /> <strong> Size:</strong>   <br /> 900*600mm, 1220*914mm, 2140*1650mm, 2440*1650/1830mm, 3300*2140/2440mm, 3660*2140/2440mm etc...<br /> <strong>Mirror Colors:</strong>   <br />  Bronze, Clear, Grey, Ultra clear,  etc.',
        MirrorColors: '- Bronze- Clear- Grey- Ultra clear  etc. ',
        APPLICATIONS:
          ' - Home decoration mirror <br /> - Bathroom mirror <br /> - Shopping malls, retails stores <br /> - Bar, restaurants, clubs, theatres <br /> - Gyms, yoga studios, dance centers <br /> - Elevator cabs, Sliding doors etc. ',
        img: '/static/productImg/SafetyMirror/img1.jpg',
        imgClistFlie: 'SafetyMirror',
        imgList: [
          { img: '/static/productImg/SafetyMirror/img1.jpg' },
          { img: '/static/productImg/SafetyMirror/img2.jpg' },
          { img: '/static/productImg/SafetyMirror/img3.jpg' },
          { img: '/static/productImg/SafetyMirror/img5.jpg' },
          { img: '/static/productImg/SafetyMirror/img6.jpg' },
          { img: '/static/productImg/SafetyMirror/img7.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/SafetyMirror/img6.jpg' },
          { img: '/static/productImg/SafetyMirror/img8.jpg' },
          { img: '/static/productImg/SafetyMirror/img7.jpg' },
          { img: '/static/productImg/SafetyMirror/img5.jpg' },
        ],
      },

      {
        text: 'Frameless Mirror',
        title: 'Frameless Mirror',
        DESCRIPTION:
          'Mirror is an integral part of people‘s daily lives, but mirrors are more widely use in such modern world, reasonable layout and use can change your room space, also can add a different kind of fun to home life.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm, 4mm, 5mm, 6mm etc <br /> <strong> Size:</strong>   <br /> 80*60cm ,70*50cm ,60*45cm, As per customer requirements.',
        MirrorColors: '- Bronze- Clear- Grey- Ultra clear  etc. ',
        APPLICATIONS:
          ' - Home decoration mirror <br /> - Bathroom mirror <br /> - Shopping malls, retails stores <br /> - Bar, restaurants, clubs, theatres <br /> - Gyms, yoga studios, dance centers <br /> - Elevator cabs, Sliding doors etc.',
        img: '/static/productImg/FramelessMirror/img5.jpeg',
        imgClistFlie: 'FramelessMirror',
        imgList: [
          { img: '/static/productImg/FramelessMirror/img5.jpeg' },
          { img: '/static/productImg/FramelessMirror/img1.jpg' },
          { img: '/static/productImg/FramelessMirror/img4.jpg' },
          { img: '/static/productImg/FramelessMirror/img6.jpeg' },
          { img: '/static/productImg/FramelessMirror/img7.jpg' },
          { img: '/static/productImg/FramelessMirror/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/FramelessMirror/img3.jpg' },
          { img: '/static/productImg/FramelessMirror/img8.jpg' },
          { img: '/static/productImg/FramelessMirror/img10.jpg' },
          { img: '/static/productImg/FramelessMirror/img11.jpg' },
        ],
      },

      {
        text: 'Antique Mirror',
        title: 'Antique Mirror',
        DESCRIPTION:
          'Antique mirror is one kind of silver mirror whose pattern is of different chemical composition but not printing.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm, 4mm, 5mm, 6mm, 8mm, 10mm etc. <br /> <strong> Size:</strong>   <br /> 1650*2200mm,1830*2440mm,3300*2440mm,etc.',
        MirrorColors: '- Clear- Ultra Clear- Dark Blue- Dark Green etc. ',
        APPLICATIONS:
          ' - Hotel and entertainment place, ex. KTV etc <br /> - Light decoration <br /> - Antique furniture <br /> - Picture frame ',
        img: '/static/productImg/AntiqueMirror/img1.jpg',
        imgClistFlie: 'AntiqueMirror',
        imgList: [
          { img: '/static/productImg/AntiqueMirror/img1.jpg' },
          { img: '/static/productImg/AntiqueMirror/img2.jpg' },
          { img: '/static/productImg/AntiqueMirror/img3.jpg' },
          { img: '/static/productImg/AntiqueMirror/img4.jpg' },
          { img: '/static/productImg/AntiqueMirror/img5.jpg' },
          { img: '/static/productImg/AntiqueMirror/img6.jpeg' },
          { img: '/static/productImg/AntiqueMirrorr/img7.jpg' },
          { img: '/static/productImg/AntiqueMirror/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/AntiqueMirror/img6.jpg' },
          { img: '/static/productImg/AntiqueMirror/img7.jpg' },
          { img: '/static/productImg/AntiqueMirror/img8.jpg' },
          { img: '/static/productImg/AntiqueMirror/img9.jpg' },
        ],
      },

      {
        text: 'Cosmetic Mirror',
        title: 'Cosmetic Mirror',
        DESCRIPTION:
          'Cosmetic Mirror, also called Makeup Mirror, is a new generation Silver or Aluminum Mirror product. The thickness of Noval Makeup Mirror comes from 1.5mm to 2.0mm (usually all silver mirror for flat mirror, 2mm for Float Aluminum Mirror, 1.5mm and 1.8mm for Sheet Aluminum Mirror). Makeup Mirror is made of high quality float glass as well as sheet glass. Though thin it is high stability it has. Usually, our Makeup Mirror takes on different colors so that it’s a good choice for Makeup Mirror and Pocket Mirror.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 1mm, 1.3mm, 1.5mm, 1.7mm, 1.8mm, 2mm. <br /> <strong> Size:</strong>   <br /> As per customer requirements <br /> <strong>Mirror Colors:</strong>   <br /> Clear， Ultra Clear',
        MirrorColors: '- Clear- Ultra Clear',
        img: '/static/productImg/CosmeticMirror/img8.jpg',
        imgClistFlie: 'CosmeticMirror',
        imgList: [
          { img: '/static/productImg/CosmeticMirror/img8.jpg' },
          { img: '/static/productImg/CosmeticMirror/img1.jpg' },
          { img: '/static/productImg/CosmeticMirror/img2.jpg' },
          { img: '/static/productImg/CosmeticMirror/img3.jpg' },
          { img: '/static/productImg/CosmeticMirror/img4.jpg' },
          { img: '/static/productImg/CosmeticMirror/img5.jpg' },
          { img: '/static/productImg/CosmeticMirror/img6.jpg' },
          { img: '/static/productImg/CosmeticMirror/img7.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/CosmeticMirror/img3.jpg' },
          { img: '/static/productImg/CosmeticMirror/img9.jpg' },
          { img: '/static/productImg/CosmeticMirror/img10.jpg' },
          { img: '/static/productImg/CosmeticMirror/img11.jpg' },
        ],
      },
    ],
  },
  {
    text: 'Decoration Glass',
    img: '/static/productImg/clearGlass/img1.jpg',
    childMenu: [
      {
        text: 'Pattern Glass',
        title: 'Pattern Glass',
        DESCRIPTION:
          'Patterned glass also called as textured glass, figured glass, and obscure glass is a decorative glass with patterns imprinted on one face of the glass. The light when passing through patterned glass diffuses due to the presence of patterns. As a result of this, we cannot see through a patterned or textured glass. It offers a translucent surface and hence provides privacy.The pattern or texture is imprinted on a glass by passing molten glass on the rollers which have a negative impression of the pattern. After passing through rollers, the glass is cooled in annealing lehr, and then the patterned glass is cut according to the requirements. Textured glass is available in a variety of designs and patterns. Tinted patterned glasses are also available which impart colourful aesthetics when used.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm,4mm,5mm,6mm,8mm,etc. <br /> <strong> Size:</strong> <br /> 1830*1220mm,1500*2000mm,1524*2134mm,1600*2000mm,1700*2000mm,1830*2440mm,1860*2520mm,2134*2440mm,2000*2500mm etc. <br /> <strong> Glass Colors:</strong> <br /> Clear, Ultra Clear, Bronze, Blue, Amber, Grey, etc.  ',
        Colors:
          '<br />   <strong> GLASS PATTERNS</strong> <br /> Nashiji, Flora, Mistlite, May Flower, Flora, Floral, Aqualite, Bamboo, Chinchilla, Diamond, <br />Galaxy, Kasumi, Hishicross, Masterlinge, Matrix, Millenium, Morgan-II, Moru-II, Mink, Oceanic, <br />Puzzle(Karatachi),  Raindown, etc.',
        APPLICATIONS:
          ' It is typically used where privacy is required simultaneously with natural light.It is used in interior applications such as doors (mostly entrance doors), windows, wall cladding, table tops, counters, shelves, backsplashes, furniture, etc.',
        img: '/static/productImg/PatternGlass/img19.jpg',
        imgClistFlie: 'PatternGlass',
        imgList: [
          { img: '/static/productImg/PatternGlass/img1.jpg' },
          { img: '/static/productImg/PatternGlass/img3.jpg' },
          { img: '/static/productImg/PatternGlass/img16.jpg' },
          { img: '/static/productImg/PatternGlass/img4.jpg' },
          { img: '/static/productImg/PatternGlass/img5.jpg' },
          { img: '/static/productImg/PatternGlass/img7.jpg' },
          { img: '/static/productImg/PatternGlass/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/PatternGlass/img20.jpg' },
          { img: '/static/productImg/PatternGlass/img6.jpg' },
          { img: '/static/productImg/PatternGlass/img15.png' },
          { img: '/static/productImg/PatternGlass/img18.jpg' },
        ],
      },

      {
        text: 'Wired Glass',
        title: 'Wired Glass',
        DESCRIPTION:
          'Wired glass is a kind of safety glass produced through a calendering process. The rolled metal wire mesh is unrolled from the wire feeeding device and sent to the molten glass liquid, and passes through the upper and lower calender rolls together with the glass liquid to form a wire glass.  The shape of the wire mesh in the wired glass is usually square or hexagon, and the surface of the glass can be patterned or smooth.In the calendering production process, a special formed by pressing a wire mesh into a semi-liquid glass ribbon. Then advantage is that the strength of wired glass is higher then that of ordinary glass. When the glass is impacted or high temperature, the glass will break and not spread out, preventing the broken pieces of corners and corners from flying out and hurting people, such as fire spreading when the glass is heated and burst, it can still maintain the fixed state and play a role in isolating the fire. So it is also callled fireproof glass. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 6mm, 6.5mm, 7mm etc. <br /> <strong> Size:</strong>   <br /> 2000*1500mm, 2200*1900mm, 2440*1830mm, 2500*2000mm, 2520*1530mm, 2520*1860mm, 2520*1880mm, 2550*1880mm, etc. ',
        APPLICATIONS:
          ' Used for roofs, skylights, balconies and other parts. Once the glass is broken, there is no danger of the shards falling.Used in fire-proof areas and smoke-proof walls, ',
        img: '/static/productImg/WiredGlass/img10.jpg',
        imgClistFlie: 'WiredGlass',
        imgList: [
          { img: '/static/productImg/WiredGlass/img9.jpg' },
          { img: '/static/productImg/WiredGlass/img2.jpg' },
          { img: '/static/productImg/WiredGlass/img3.jpg' },
          { img: '/static/productImg/WiredGlass/img5.jpg' },
          { img: '/static/productImg/WiredGlass/img6.jpg' },
          { img: '/static/productImg/WiredGlass/img7.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/WiredGlass/img1.jpg' },
          { img: '/static/productImg/WiredGlass/img11.jpg' },
          { img: '/static/productImg/WiredGlass/img12.jpeg' },
          { img: '/static/productImg/WiredGlass/img12.jpg' },
        ],
      },

      {
        text: 'Acid Etched Glass',
        title: 'Acid Etched Glass',
        DESCRIPTION:
          'Acid Etched Glass that’s no finger print glass and translucent glass has a uniformly smooth, silky surface; To manufacture this type of glass, annealed glass is treated with hydrofluoric acid to give the surface a satin frosted appearance. Silhouettes are subtly obscured and lines softened to provide countless opportunities for both internal and external applications. Having similar light transmission properties to clear glass, acid etched glass facilitates the need for privacy without compromising the need for natural Light. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 4mm, 5mm, 6mm, 8mm, 10mm, 12mm etc. <br /> <strong> Size:</strong>   <br />  3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm etc. <br /> <strong>Glass Colors:</strong>   <br />  Clear, Bronze, Grey, Green, Blue etc.',
        APPLICATIONS:
          ' Acid-etched glass applications vary widely including shower doors, office doors and windows, kitchen and etched glass windows, etched glass doors, decorative glass walls, and satin glass furniture. Acid-etched glass is an excellent option for applications where you desire privacy and decorative quality.',
        img: '/static/productImg/AcidFrosted/img2.jpg',
        imgClistFlie: 'AcidFrosted',
        imgList: [
          { img: '/static/productImg/AcidFrosted/img1.jpg' },
          { img: '/static/productImg/AcidFrosted/img2.jpg' },
          { img: '/static/productImg/AcidFrosted/img3.jpg' },
          { img: '/static/productImg/AcidFrosted/img4.jpg' },
          { img: '/static/productImg/AcidFrosted/img8.jpg' },
          { img: '/static/productImg/AcidFrosted/img11.jpg' },
          { img: '/static/productImg/AcidFrosted/img10.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/AcidFrosted/img5.jpeg' },
          { img: '/static/productImg/AcidFrosted/img6.jpg' },
          { img: '/static/productImg/AcidFrosted/img7.jpeg' },
          { img: '/static/productImg/AcidFrosted/img9.jpg' },
        ],
      },

      {
        text: 'Frosted Glass',
        title: 'Frosted Glass',
        DESCRIPTION:
          'Frosted glass is produced by the sandblasting of clear sheet glass. This creates a pitted surface on one side of the glass pane and has the effect of rendering the glass translucent by scattering the light which passes through, thus blurring images while still transmitting light. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 4mm, 5mm, 6mm, 8mm, 10mm, 12mm etc... <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm etc.  <br /> <strong>Glass Colors:</strong>   <br />  Clear, Bronze, Grey, Green, Blue etc.',
        APPLICATIONS:
          ' Frosted glass applications vary widely including shower doors, office doors and windows, kitchen and etched glass windows, etched glass doors, decorative glass walls, and satin glass furniture. Acid-etched glass is an excellent option for applications where you desire privacy and decorative quality.',
        img: '/static/productImg/FrostedGlass/img1.jpeg',
        imgClistFlie: 'FrostedGlass',
        imgList: [
          { img: '/static/productImg/FrostedGlass/img1.jpeg' },
          { img: '/static/productImg/FrostedGlass/img2.jpg' },
          { img: '/static/productImg/FrostedGlass/img3.jpg' },
          { img: '/static/productImg/FrostedGlass/img4.jpg' },
          { img: '/static/productImg/FrostedGlass/img5.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/FrostedGlass/img1.jpg' },
          { img: '/static/productImg/FrostedGlass/img2.jpg' },
          { img: '/static/productImg/FrostedGlass/img3.jpg' },
          { img: '/static/productImg/FrostedGlass/img4.jpg' },
        ],
      },

      {
        text: 'Lacquered Glass',
        title: 'Lacquered Glass',
        DESCRIPTION:
          'The lacquered glass is a float glass, with a layer of lacquered paint on one side whose grip is reinforced with a special treatment. The lacquered side is resistant to UV rays and discoloration, as well as moisture, could be used in kitchens or bathrooms. The traditional process is resistant to 80ºC and there is a diversified range of color with vitrified treatment that allows further tempering treatments.  This glass is unique for architectural projects, combining modernity and the flexibility provided by the enhanced range of colors. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm, 4mm, 5mm, 6mm, 8mm etc. <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm etc. <br /> <strong> Colors:</strong>   <br /> Black, White, Red, Bronze, Grey, Green, Blue etc.',
        APPLICATIONS:
          ' - Wall Cladding: Living rooms, Kitchens and Bathrooms <br /> - Partitions: Storefronts and Offices <br /> - Furnitures: Table tops, Shelves, Displays.',
        img: '/static/productImg/LacqueredGlass/img2.jpg',
        imgClistFlie: 'LacqueredGlass',
        imgList: [
          { img: '/static/productImg/LacqueredGlass/img1.jpg' },
          { img: '/static/productImg/LacqueredGlass/img2.jpg' },
          { img: '/static/productImg/LacqueredGlass/img3.jpg' },
          { img: '/static/productImg/LacqueredGlass/img4.jpg' },
          { img: '/static/productImg/LacqueredGlass/img5.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/LacqueredGlass/img8.jpg' },
          { img: '/static/productImg/LacqueredGlass/img6.jpg' },
          { img: '/static/productImg/LacqueredGlass/img7.jpg' },
          { img: '/static/productImg/LacqueredGlass/img9.jpg' },
        ],
      },

      {
        text: 'Aquarium Glass',
        title: 'Aquarium Glass',
        DESCRIPTION:
          'Aquarium Glass is made of high qualty clear float glass and low iron glass. ',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 2.8mm-19mm <br /> <strong> Size:</strong>   <br /> As per customer requirements',
        img: '/static/productImg/AquariumGlass/img2.jpg',
        imgClistFlie: 'AquariumGlass',
        imgList: [
          { img: '/static/productImg/AquariumGlass/img1.jpg' },
          { img: '/static/productImg/AquariumGlass/img2.jpg' },
          { img: '/static/productImg/AquariumGlass/img3.jpg' },
          { img: '/static/productImg/AquariumGlass/img4.jpg' },
          { img: '/static/productImg/AquariumGlass/img5.jpg' },
          { img: '/static/productImg/AquariumGlass/img7.jpg' },
          { img: '/static/productImg/AquariumGlass/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/AquariumGlass/img13.jpg' },
          { img: '/static/productImg/AquariumGlass/img9.jpg' },
          { img: '/static/productImg/AquariumGlass/img4.jpg' },
          { img: '/static/productImg/AquariumGlass/img14.jpg' },
        ],
      },
    ],
  },

  {
    text: 'Float Glass',
    img: '/static/productImg/clearGlass/img2.jpg',
    childMenu: [
      {
        text: 'Clear Glass',
        title: 'Clear Glass',
        DESCRIPTION:
          'Clear Float Glass is produced by melting sand, soda ash, dolomite, and limestone together to create a continuous ribbon that flows from a furnace and "floats" over a bed of molten tin, which is then carefully cooled to "anneal" the glass.Clear float glass can be processed into mirror, heat strengthened, toughened, laminated, curved glass and Insulating Glass Units.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 1.1mm,1.8mm,2mm,2.7mm,2.5mm,3mm,4mm,5mm,5.5mm,6mm,8mm,10mm,12mm,15mm,19mm etc. <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,<br />1830*2440 etc.',
        APPLICATIONS:
          '- Construction<br /> - Mirrors <br /> - Furniture and decoration<br /> - Aquariums<br /> - Optical instruments <br /> - Automobiles',
        img: '/static/productImg/clearGlass/img1.jpg',
        imgClistFlie: 'clearGlass',
        imgList: [
          { img: '/static/productImg/clearGlass/img1.jpg' },
          { img: '/static/productImg/clearGlass/img2.jpg' },
          { img: '/static/productImg/clearGlass/img3.jpg' },
          { img: '/static/productImg/clearGlass/img4.jpg' },
          { img: '/static/productImg/clearGlass/img6.jpg' },
          { img: '/static/productImg/clearGlass/img7.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/clearGlass/img10.jpg' },
          { img: '/static/productImg/clearGlass/img11.jpg' },
          { img: '/static/productImg/clearGlass/img8.jpg' },
          { img: '/static/productImg/clearGlass/img9.jpg' },
        ],
      },

      {
        text: 'Low Iron Glass',
        title: 'Low Iron Glass',
        DESCRIPTION:
          'Low Iron Glass is made from a special silica sand that has naturally lower iron levels than that of clear glass. It’s this lower iron content that provides the color neutrality and all but eradicates the greenish tint that’s found in clear glass.This product is characterized by its crystal clear appearance and high light transmission (≥91% of visible light), and is significantly  less green in appearance. Low Iron Glass enhances the appearance of natural materials. Where edges of the glass are exposed as a design feature, the contrast in terms of clarity is even. more apparent.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm,3.2mm,4mm,5mm,6mm,8mm,10mm,12mm,15mm,19mm etc. <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm etc...',
        APPLICATIONS:
          '- Glass partitions <br /> - Shower enclosures <br /> - Shelving and display cases <br /> - Display windows <br /> - Mirrors <br /> - Framing glass <br /> - Greenhouses <br /> - Floors and stairs',
        img: '/static/productImg/LowIronGlass/img1.jpg',
        imgClistFlie: 'LowIronGlass',
        imgList: [
          { img: '/static/productImg/LowIronGlass/img1.jpg' },
          { img: '/static/productImg/LowIronGlass/img2.jpg' },
          { img: '/static/productImg/LowIronGlass/img3.jpg' },
          { img: '/static/productImg/LowIronGlass/img4.jpg' },
          { img: '/static/productImg/LowIronGlass/img5.jpg' },
          { img: '/static/productImg/LowIronGlass/img10.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/LowIronGlass/img6.jpg' },
          { img: '/static/productImg/LowIronGlass/img7.jpg' },
          { img: '/static/productImg/LowIronGlass/img8.jpg' },
          { img: '/static/productImg/LowIronGlass/img9.jpg' },
        ],
      },
      {
        text: 'Tinted Glass',
        title: 'Tinted Glass',
        DESCRIPTION:
          'Tinted glass is made by including coloring additives to normal clear glass during the manufacturing process. The majority of tinting is done with shades of bronze, grey, blue or green. These tones of glass offer the ability to protect your home’s interior from excess UV rays, reducing UV transmittance, solar heat gain and glare.			With the sunlight absorbing properties in tinted glass its ideally suited to warmer climates when ideal window orientation is not achievable. The colored tint within glass absorbs a greater proportion of solar heat in comparison to clear glass.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm,4mm,5mm,5.5mm,6mm,8mm,10mm,12mm etc. <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm etc...',
        Colors:
          '<br />   <strong> Colors</strong> <br /> Clear, Euro Bronze, Golden Bronze Mist Grey, Euro Grey, Dark Grey, French Green, Dark Green, Lake Blue, Dark Blue, Royal Blue, and Pink etc.',
        APPLICATIONS:
          '- Architecture <br /> - Mirrors <br /> - Furniture and decoration <br /> - Optical instruments <br /> - Automobiles',
        img: '/static/productImg/TintedGlass/img2.jpg',
        imgClistFlie: 'TintedGlass',
        imgList: [
          { img: '/static/productImg/TintedGlass/img1.jpg' },
          { img: '/static/productImg/TintedGlass/img2.jpg' },
          { img: '/static/productImg/TintedGlass/img3.jpg' },
          { img: '/static/productImg/TintedGlass/img4.jpg' },
          { img: '/static/productImg/TintedGlass/img5.jpg' },
          { img: '/static/productImg/TintedGlass/img6.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/TintedGlass/img7.jpg' },
          { img: '/static/productImg/TintedGlass/img10.jpg' },
          { img: '/static/productImg/TintedGlass/img11.jpg' },
          { img: '/static/productImg/TintedGlass/img12.jpg' },
        ],
      },

      {
        text: 'Reflective Glass',
        title: 'Reflective Glass',
        DESCRIPTION:
          'Reflective glass is clear or tinted glass that has a very thin layer of metal or metallic oxide on the surface.One of the major benefits of reflective glass is that it is heatproof. Can absorb and reflect harmful UV and infrared rays from the sun while allowing natural visible light to pass through. it also prevents excessive solar glare.Reflective glass is used primarily to combat rising energy consumption by blocking solar heat and glare from entering building.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm,4mm,5mm,5.5mm,6mm,8mm,10mm,12mm etc. <br /> <strong> Size:</strong>   <br /> 3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm etc...',
        Colors:
          '<br /> <strong> Colors</strong>   <br /> Clear, Euro Bronze, Golden Bronze Mist Grey, Euro Grey, Dark Grey, French Green, Dark Green, Lake Blue, Dark Blue, Royal Blue, and Pink etc.',
        APPLICATIONS:
          'Reflective glass is used in a variety of applications, both interior and exterior. exterior applications include commercial facade, shopping malls, educational institutions, stand-alone storefronts, air traffic control towers, restaurants, hotel rooms, petrol bunk windows. Interior applications include picture framing, display cabinets, display windows, tabletops.Reflective glass is primarily used to combat the rising rate of energy consumption by blocking solar heat and glare from entering inside.			It also provudes UV and  IR protection and prevents excessive solar glare. reflective also offers aesthetic benefits such as color flexibility and privacy benefits',
        img: '/static/productImg/ReflectiveGlass/img1.jpg',
        imgClistFlie: 'ReflectiveGlass',
        imgList: [
          { img: '/static/productImg/ReflectiveGlass/img11.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img2.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img3.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img4.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img5.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img6.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img7.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/ReflectiveGlass/img10.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img1.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img8.jpg' },
          { img: '/static/productImg/ReflectiveGlass/img9.jpg' },
        ],
      },

      {
        text: 'LOW E Glass',
        title: 'LOW E Glass',
        DESCRIPTION:
          'Low-Emissivity glass ( low-E glass) has been coated with an extremely (microscopically) thin layer of silver, provides natural light transmission and a low U-value to help limit heat gain and thermal energy transfer.			In the winter, Low-E glass stops heat from escaping and reflects it back inside your home. In the summer, when UV rays hit your windows, a Low-E coating reflects the heat off the window, blocking it from entering the house.Low emissivity glass keeps a home cool in the summer and warm in the winter.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3mm,3.2mm,4mm,5mm,5.5mm,6mm,8mm,10mm,12mm etc. <br /> <strong> Size:</strong>   <br />',
        Size: '3300*2140mm,3660*2140mm,3300*2250mm,3660*2250mm,3300*2440mm,3660*2440mm,etc.',
        APPLICATIONS:
          'The applications for architectural low-E glazing are wide ranging. From windows and curtain walls to roofs and skylights, in fact, any application where glazing is a physical barrier between the inside and outside of a building, low-E glazing can be considered.',
        img: '/static/productImg/LOWEGlass/img2.jpg',
        imgClistFlie: 'LOWEGlass',
        imgList: [
          { img: '/static/productImg/LOWEGlass/img1.jpg' },
          { img: '/static/productImg/LOWEGlass/img2.jpg' },
          { img: '/static/productImg/LOWEGlass/img3.jpg' },
          { img: '/static/productImg/LOWEGlass/img4.jpg' },
          { img: '/static/productImg/LOWEGlass/img5.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/LOWEGlass/img7.jpg' },
          { img: '/static/productImg/LOWEGlass/img6.jpg' },
          { img: '/static/productImg/LOWEGlass/img9.jpg' },
          { img: '/static/productImg/LOWEGlass/img8.jpg' },
        ],
      },

      {
        text: 'Auto Glass',
        title: 'Auto Glass',
        DESCRIPTION:
          'Glass that is used in automobiles can be broadly termed as automotive glass. It is a kind of processed float glass that undergoes heating and chemical treatments. Through this toughening process, the glass becomes sturdier and stronger to handle stress from external factors.			Automotive glass can also be processed to include other beneficial properties like protection against harmful infrared rays, prevention of excessive heating in the car, and reduction of noise. All these properties can be inculcated in the glass for optimum comfort while you drive your vehicle.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 2.1mm to 6mm. <br /> <strong> Size:</strong>   <br />',
        Size: '3300x2140mm, 1650x2140mm, 1650x2440mm, 1650x2200mm, your final size',
        Colors:
          '<br /> <strong> VARIETIES</strong>   <br /> There are primarily two kinds of glass that are used in the automobile sector.		<br />  <br /> <strong>	Tempered Glass </strong>	<br />		Tempered glass is float glass that is strengthened through a unique toughening process. Float glass is subjected to a heating process after which it is quenched. The instant cooling of glass creates compressive stress on the surface of the glass and internal stress on its body. This helps the glass to become physically and thermally stronger than normal glass. It is sturdier than glass with the same thickness and invulnerable to tensile stress.Tempered automotive glass is highly effective in lowering impact-related breakage. In case the glass is hit by an external force, your safety will not be compromised as it shatters into small pieces. Tempered automotive glass is also durable and dramatically efficient in reducing noise and vibrations inside your vehicle. It also offers a clear vision for a comfortable riding experience. <br />  <br /> <strong> Laminated Glass	</strong> <br />		Two or more sheets of either annealed or heat-treated glass are separated by a special PVB interlayer to ensure perfect adhesion between constituent elements. The interlayer is normally made of PVB (Poly Vinyl Butyral), which is a type of resin that provides strong binding, optical clarity, and toughness			Laminated automotive glass offers enhanced safety on breakage. When it breaks, the glass pieces remain stuck to the PVB interlayer and do not fall apart. When a normal glass breaks, it forms large shards which can cause serious injury. The interlayer acts as an extra layer of protection against such breakage risks. Laminated automotive glass also has a greater impact, stress, and intrusion resistance; making it significantly better than normal glass. For better security, endurance, and optical clarity, go for laminated automotive glassLaminated safety glass that comes with greater strength and impact resistance and provides level 2 and level 3 protection against burglar attacks. This safety glass also effectively reduces noise for enhanced acoustic performance',

        img: '/static/productImg/AutoGlass/img7.jpg',
        imgClistFlie: 'AutoGlass',
        imgList: [
          { img: '/static/productImg/AutoGlass/img1.jpg' },
          { img: '/static/productImg/AutoGlass/img2.jpg' },
          { img: '/static/productImg/AutoGlass/img5.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/AutoGlass/img3.jpg' },
          { img: '/static/productImg/AutoGlass/img4.jpg' },
          { img: '/static/productImg/AutoGlass/img6.jpg' },
        ],
      },
    ],
  },

  {
    text: 'Special Glass',
    img: '/static/productImg/clearGlass/img1.jpg',
    childMenu: [
      {
        text: 'Anti Reflective Glass',
        title: 'Anti Reflective Glass',
        DESCRIPTION:
          'Anti reflective coated glass,which means there’s a anti reflective coating on glass surface which can decrease the glass light reflectance. Glass conventionally used to frame pictures reflects approximately 8% of light, but the coating can reduce this to as little as 0.5% or one sixteenth as much.				Due to the high transparency of anti-reflecting glass, the objects on the other side of the glazing are displayed optimally. The observer is not bothered by the reflection of light or the environment and sees the objects, their contrast and colors truthfully.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 4mm, 5mm, 6mm, 8mm, 10mm, 12mm etc. <br /> <strong> Size:</strong>   <br />',
        Size: '1650*2140mm,1650*2250mm,1650*2440mm,1830*2140mm,1830*2440mm,3300*2140mm, etc.',
        APPLICATIONS:
          ' - Museum displays and showcases and protection of paintings <br /> - Displays and showcases in shops <br /> - Control Towers, control <br /> - and monitoring rooms <br /> - Partitions of supporters boxes on stadiums <br /> - Glazing in panorama restaurants- Partitions in hospitals, clean rooms, etc. <br /> - Television Studios ( avoid reflections for cameras) <br /> - Translation rooms and sound studios (conference rooms, recording studios, etc. ) <br /> - Zoos and aquariums <br /> - Control booths of construction equipment (cranes , tractors, etc. ) <br /> - Protective glass of ATM’s <br /> - Signs or billboards in stations, airports, etc.',
        img: '/static/productImg/AntiReflectiveGlass/img1.jpg',
        imgClistFlie: 'AntiReflectiveGlass',
        imgList: [
          { img: '/static/productImg/AntiReflectiveGlass/img1.jpg' },
          { img: '/static/productImg/AntiReflectiveGlass/img2.jpg' },
          { img: '/static/productImg/AntiReflectiveGlass/img3.jpg' },
          { img: '/static/productImg/AntiReflectiveGlass/img4.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/AntiReflectiveGlass/img8.jpg' },
          { img: '/static/productImg/AntiReflectiveGlass/img5.jpg' },
          { img: '/static/productImg/AntiReflectiveGlass/img6.jpg' },
          { img: '/static/productImg/AntiReflectiveGlass/img7.jpg' },
        ],
      },

      {
        text: 'Refrigerator Glass',
        title: 'Refrigerator Glass',
        DESCRIPTION:
          'Refrigerator glasses includes two main areas: robust glass shelves and versatile glass fronts. Both offer an extensive array of design and functional options for customization. Our glass shelves and decorative front panels can be tailored to your exact requirement.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3.2mm, 4mm <br /> <strong> Size:</strong>   <br />   custom sizes',
        img: '/static/productImg/RefrigeratorGlass/img1.jpg',
        imgClistFlie: 'RefrigeratorGlass',
        imgList: [
          { img: '/static/productImg/RefrigeratorGlass/img1.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img3.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img4.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img5.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img7.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/RefrigeratorGlass/img2.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img7.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img8.jpg' },
          { img: '/static/productImg/RefrigeratorGlass/img6.jpg' },
        ],
      },

      {
        text: 'Silk Printing Glass',
        title: 'Silk Screen Printing Glass',
        DESCRIPTION:
          'Silk Screen Ceramic Glass is the ceramic fritted glass through screen printing on screen plate, roller printing machine to print on the glass surface, and then after drying, heat treatment (toughened, or semi-toughened), the ink permanently sintered on the glass surface. As a result silk-screen printed glass is durable, scratch-proof, solar shading and with anti-glare effect.  Its acid and moisture resistant features maintain colors for decades, whereas various color and graphic choices are an option. The tempered silk-screen printed glass has safety glass properties.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br />  4-19mm <br /> <strong> Size:</strong>   <br />',
        Size: 'Min.200x300mm, Max.3300mmx13000mm, custom sizes',
        APPLICATIONS:
          'Silk Screen Printing Glass is durable, decorative, and functional glass. Images are UV, fade, and scratch-resistant, suitable for any interior or exterior application. ',
        img: '/static/productImg/SilkScreenPrintingGlass/img1.jpg',
        imgClistFlie: 'SilkScreenPrintingGlass',
        imgList: [
          { img: '/static/productImg/SilkScreenPrintingGlass/img1.jpg' },
          { img: '/static/productImg/SilkScreenPrintingGlass/img2.jpg' },
          { img: '/static/productImg/SilkScreenPrintingGlass/img5.jpg' },
          { img: '/static/productImg/SilkScreenPrintingGlass/img7.jpg' },
          { img: '/static/productImg/SilkScreenPrintingGlass/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/SilkScreenPrintingGlass/img3.jpg' },
          { img: '/static/productImg/SilkScreenPrintingGlass/img4.jpg' },
          { img: '/static/productImg/SilkScreenPrintingGlass/img6.jpg' },
        ],
      },

      {
        text: 'U Channel Profile Glass',
        title: 'U channel profile glass',
        DESCRIPTION:
          'U profile glass is one kind of casting glasses. It is a progress of forming in the computer-control smelting furnace that enables it to keep excellent quality and precision. Its high mechanical strength enables it to be fixed on high-rise buildings and other buildings which need good lighting. And this can save the buildings from extra vertical and horizontal underpinning. U profile glass featured by its good lighting, heat insulation and preservation, sound insulation and noise protection—-it is one of the new type environment-friendly and economical glasses.',
        Colors:
          '<br /> <strong> Daylighting</strong>   <br /> Diffuses light & minimizes glare<br /> <strong> Thermal Performance</strong>   <br /> U-Value range = 0.49 to 0.19  <br /> <strong> Great Spans</strong>   <br /> Glass walls of limitless widths & heights up to 12 meters  <br /> <strong> Elegance</strong>   <br />  Glass-to-glass corners & serpentine curves   <br /> <strong> Seamless </strong>   <br />  No vertical metal supports required   <br /> <strong> Lightweight</strong>   <br />   7mm thick U profile glass is easy to handle  <br /> <strong> Unitized Options</strong>   <br /> Speedier installation  <br /> <strong> Adaptable</strong>   <br /> To seamlessly tie in vision areas, change elevations & planes',
        ThermalPerformance: ' U-Value range = 0.49 to 0.19',
        GreatSpans:
          ',Glass walls of limitless widths & heights up to 12 meters.',
        Elegance: ' Glass-to-glass corners & serpentine curves',
        Seamless: ' No vertical metal supports required',
        Lightweight: ' 7mm thick U profile glass is easy to handle',
        UnitizedOptions: ' Speedier installation',
        Adaptable:
          'To seamlessly tie in vision areas, change elevations & planes',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 6.5mm, 7mm, <br /> <strong> Channel Glass Width: </strong>   <br /> 260mm, 320mm <br /> <strong> U Profile Glass Length: </strong>   <br /> 3m, 4m, ~7.5m  <br /> <strong> Glass substrate: </strong>   <br /> low iron float glass/ ultra clear float glass/ super clear float glass ',
        APPLICATIONS:
          'U-Profile Glazing System is an innovative sophisticated option for glass facade ;construction, overhead and partition glazing. They are suitable for interior and exterior applications. ',
        img: '/static/productImg/UChannelProfileGlass/img1.jpg',
        imgList: [
          { img: '/static/productImg/UChannelProfileGlass/img1.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img2.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img3.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img7.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img8.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/UChannelProfileGlass/img4.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img5.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img6.jpg' },
          { img: '/static/productImg/UChannelProfileGlass/img9.jpg' },
        ],
      },

      {
        text: 'Green House',
        title: 'Green House',
        DESCRIPTION:
          'Greenhouses have long been an integral part of both agriculture and hobby gardening. Essentially a building constructed almost entirely from glass, a greenhouse is designed to let in as much natural light, including UV and infrared radiation, as possible. This creates what’s known as the “greenhouse effect,” wherein light and heat energy build up in a space and are trapped there, producing an interior climate that is several degrees warmer than outdoors and thus facilitates the growth of plants that would not normally thrive in a given regional climate.',
        SPECIFICATION:
          '<br />   <strong> Thickness:</strong> <br /> 3.2mm,4mm,5mm, etc. <br /> <strong> Size:</strong>   <br /> As per customer requirements <br /> <strong> Glass Substrate:</strong>   <br /> Clear Glass/Low Iron Glass/Pattern Glass/Low E Glass/Temepred Glass',
        Glasssubstrate:
          'Clear Glass/Low Iron Glass/Pattern Glass/Low E Glass/Temepred Glass.',
        Colors:
          '<br /> <strong> Pros Of Glass Greenhouse Glazing</strong>   <br /> - Excellent light transmission <br />- Very durable and long-lasting (if not broken) <br />- Aesthetically pleasing  <br />- Flame-resistant Easy to replace and buy second-hand- Natural substance ',
        img: 'static/productImg/GreenHouse/img1.jpg',
        imgList: [
          { img: '/static/productImg/GreenHouse/img1.jpg' },
          { img: '/static/productImg/GreenHouse/img2.jpg' },
          { img: '/static/productImg/GreenHouse/img3.jpg' },
          { img: '/static/productImg/GreenHouse/img4.jpg' },
          { img: '/static/productImg/GreenHouse/img5.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/GreenHouse/img6.jpg' },
          { img: '/static/productImg/GreenHouse/img7.jpg' },
          { img: '/static/productImg/GreenHouse/img8.jpg' },
          { img: '/static/productImg/GreenHouse/img9.jpg' },
        ],
      },
    ],
  },
  {
    text: 'WPC Panel',
    childMenu: [
      {
        text: 'WPC Panel',
        title: 'WPC Panel',
        DESCRIPTION:
          'WPC Wall Panel is a patented technology that mixes resin, lignocellulosic materials and polymer materials in a certain proportion, and then makes a certain shape profile through high temperature, die extrusion, molding and other processes. <br /> The production process is as follows: <br />  raw material mixing → Raw material granulation → batching → drying → extrusion → vacuum cooling and shaping → pulling and cutting → inspection and packaging → packaging and storage. <br /> <br />  WPC Panel is a wood-plastic material, and the wood-plastic products usually made of PVC foaming process are called WPC Panel. The main raw material of WPC Panel is a new type of green environmental protection material (30% PVC+69% wood powder+1% colorant formula), WPC Panel is generally composed of two parts, the substrate and the color layer, the substrate is made of wood powder and PVC plus other Synthesis of reinforcing additives, and the color layer is adhered to the surface of the substrate by PVC color films with different textures,Its colors are various, and it does not need to be painted twice, and it is formed once.',
        img: 'static/productImg/WPC/img1.jpg',
        imgList: [
          { img: '/static/productImg/WPC/img14.jpg' },
          { img: '/static/productImg/WPC/img15.jpg' },
          { img: '/static/productImg/WPC/img16.jpg' },
          { img: '/static/productImg/WPC/img5.jpg' },
          { img: '/static/productImg/WPC/img9.jpg' },
          { img: '/static/productImg/WPC/img4.jpg' },
        ],
        imgListTwo: [
          { img: '/static/productImg/WPC/img6.jpg' },
          { img: '/static/productImg/WPC/img7.jpg' },
          { img: '/static/productImg/WPC/img3.jpg' },
          { img: '/static/productImg/WPC/img2.jpg' },
        ],
      },
    ],
  },
];

export { MeunsItemList };
